// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3rJj6","cell":"ColumnAccessor_cell__gSvLm","firstCellAccent":"ColumnAccessor_firstCellAccent__3D2dj"};